"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StandardView = StandardView;
var _react = _interopRequireWildcard(require("react"));
var _wmStandardFormContainer = _interopRequireDefault(require("../wm-standard-form-container"));
var _pagesController = _interopRequireDefault(require("../pages-controller"));
var _popup = _interopRequireDefault(require("../popup"));
var _api = _interopRequireDefault(require("../../services/api"));
var _stringMask = _interopRequireDefault(require("string-mask"));
require("./styles.css");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _showDetails = _interopRequireDefault(require("../show-details"));
var _moment = _interopRequireDefault(require("moment"));
var _fieldTypes = require("../../constants/field-types");
var _actionTypes = require("../../constants/action-types");
var _index = require("../../utils/index");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function StandardView(props) {
  //PROPS
  var _props = _objectSpread({}, props),
    descriptor = _props.descriptor,
    biRef = _props.biRef,
    filtersContainer = _props.filtersContainer,
    filtersBtnContainer = _props.filtersBtnContainer,
    filterBtn = _props.filterBtn,
    filterCleanBtn = _props.filterCleanBtn,
    customButtons = _props.customButtons,
    addNew = _props.addNew,
    addBtn = _props.addBtn,
    addBtnText = _props.addBtnText,
    renderItem = _props.renderItem,
    tableContainer = _props.tableContainer,
    th = _props.th,
    tr = _props.tr,
    td = _props.td,
    onItemClick = _props.onItemClick,
    rangeDisplay = _props.rangeDisplay,
    pageLinkClass = _props.pageLinkClass,
    pageItemClass = _props.pageItemClass,
    pageActiveLinkClass = _props.pageActiveLinkClass;
  //STATE
  var _descriptor = _objectSpread({}, descriptor),
    fields = _descriptor.fields,
    actions = _descriptor.actions,
    sortOptions = _descriptor.sortOptions;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    cols = _useState2[0],
    setCols = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    filters = _useState4[0],
    setFilters = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    numPages = _useState6[0],
    setNumPages = _useState6[1];
  var _useState7 = (0, _react.useState)(findPageValue()),
    _useState8 = _slicedToArray(_useState7, 2),
    page = _useState8[0],
    setPage = _useState8[1];
  var _useState9 = (0, _react.useState)(""),
    _useState10 = _slicedToArray(_useState9, 2),
    strFilters = _useState10[0],
    setStrFilters = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    infos = _useState12[0],
    setInfos = _useState12[1];
  var _useState13 = (0, _react.useState)(0),
    _useState14 = _slicedToArray(_useState13, 2),
    pageSize = _useState14[0],
    setPageSize = _useState14[1];
  var _useState15 = (0, _react.useState)(0),
    _useState16 = _slicedToArray(_useState15, 2),
    totalElements = _useState16[0],
    setTotalElements = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showAlert = _useState18[0],
    setShowAlert = _useState18[1];
  var _useState19 = (0, _react.useState)(),
    _useState20 = _slicedToArray(_useState19, 2),
    confirmFunction = _useState20[0],
    setConfirmFunction = _useState20[1];
  var _useState21 = (0, _react.useState)(""),
    _useState22 = _slicedToArray(_useState21, 2),
    alertMessage = _useState22[0],
    setAlertMessage = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = _slicedToArray(_useState23, 2),
    confirmBtn = _useState24[0],
    setConfirmBtn = _useState24[1];
  var _useState25 = (0, _react.useState)(""),
    _useState26 = _slicedToArray(_useState25, 2),
    confirmText = _useState26[0],
    setConfirmText = _useState26[1];
  var _useState27 = (0, _react.useState)(""),
    _useState28 = _slicedToArray(_useState27, 2),
    closeText = _useState28[0],
    setCloseText = _useState28[1];
  var _useState29 = (0, _react.useState)(""),
    _useState30 = _slicedToArray(_useState29, 2),
    sortParam = _useState30[0],
    setSortParam = _useState30[1];
  var _useState31 = (0, _react.useState)({}),
    _useState32 = _slicedToArray(_useState31, 2),
    displayTable = _useState32[0],
    setDisplayTable = _useState32[1];
  var _useState33 = (0, _react.useState)({}),
    _useState34 = _slicedToArray(_useState33, 2),
    auxObj = _useState34[0],
    setAuxObj = _useState34[1];
  var _useState35 = (0, _react.useState)(null),
    _useState36 = _slicedToArray(_useState35, 2),
    showError = _useState36[0],
    setShowError = _useState36[1];
  var invalidFieldNames = ["label", "name", "type", "mask", "loadByIdUrl", "labelField", "hideOnMobile", "loadItemUrl", "valueField"];
  var _biRef = {};
  (0, _react.useEffect)(function () {
    if (sortOptions) setSortParam(sortOptions[0].param);
  }, [sortOptions]);
  (0, _react.useEffect)(function () {
    if (fields) {
      fields.sort(function (a, b) {
        var orderA = a.presentationOrder || 1;
        var orderB = b.presentationOrder || 1;
        return orderA - orderB;
      });
    }
    var infoCols = generateCols(fields, 0);
    var actionCols = generateActionCols(actions || [], fields || []);
    setCols(infoCols.concat(actionCols));
  }, [descriptor]);
  (0, _react.useEffect)(function () {
    if (descriptor && (!(descriptor !== null && descriptor !== void 0 && descriptor.sortOptions) || sortParam !== "")) {
      getInfos();
    }
  }, [page, strFilters, descriptor, sortParam]);
  (0, _react.useEffect)(function () {
    var table = {
      length: infos.length
    };
    var _loop = function _loop(i) {
      var item = infos[i];
      table[i] = {};
      var _loop2 = function _loop2(j) {
        var col = cols[j];
        extractCol(col, item).then(function (res) {
          table[i][j] = res;
          setDisplayTable(_objectSpread({}, table));
        });
      };
      for (var j = 0; j < cols.length; j++) {
        _loop2(j);
      }
    };
    for (var i = 0; i < infos.length; i++) {
      _loop(i);
    }
  }, [infos, cols]);
  function findPageValue() {
    return parseInt((0, _index.getParameterFromURL)("page")) - 1 || 0;
  }
  function generateCols(fields, level) {
    var newCols = [];
    var _loop3 = function _loop3() {
      var field = fields[i];
      if (field.showOnResult) {
        if (field.type !== _fieldTypes.COMPLEX) {
          if (field.type === _fieldTypes.MULTIPLE_SELECTION || field.type === _fieldTypes.SIMPLE_SELECTION) {
            var itens = field.itens;
            if (!itens) {
              itens = _api.default.get(field.loadItemUrl, true);
            }
            setAuxObj(function (auxObj) {
              var newAuxObj = _objectSpread({}, auxObj);
              newAuxObj[field.name] = itens;
              return newAuxObj;
            });
          }
          newCols.push({
            label: field.label,
            name: field.name,
            type: field.type,
            mask: field.mask,
            loadByIdUrl: field.loadByIdUrl,
            hideOnMobile: field.hideOnMobile,
            labelField: field.labelField || field.presentationField,
            valueField: field.valueField || field.idField
          });
        } else {
          var auxCols = generateCols(field.fields, level + 1);
          auxCols.forEach(function (col) {
            return newCols.push(_objectSpread(_objectSpread({}, col), {}, _defineProperty({}, level, field.name)));
          });
        }
      }
    };
    for (var i = 0; i < (fields === null || fields === void 0 ? void 0 : fields.length); i++) {
      _loop3();
    }
    return newCols;
  }
  function hasHideOnMobile(fields) {
    var ret = false;
    fields.forEach(function (field) {
      if (field.hideOnMobile || field.type === _fieldTypes.COMPLEX && hasHideOnMobile(field.fields)) ret = true;
    });
    return ret;
  }
  function generateActionCols(actions) {
    var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var newCols = [];
    actions.forEach(function (action) {
      newCols.push({
        label: action.label,
        type: _actionTypes.ACTION,
        action: action
      });
    });
    if (hasHideOnMobile(fields)) {
      newCols.push({
        label: "Ver Mais",
        type: _actionTypes.ACTION,
        showOnlyOnMobile: true,
        action: {
          type: "SHOW_DETAIL",
          icon: "fa-search"
        }
      });
    }
    return newCols;
  }
  function executeAction(_x, _x2) {
    return _executeAction.apply(this, arguments);
  }
  function _executeAction() {
    _executeAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(action, item) {
      var func;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            func = /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var url, params, res;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      setAlertMessage("carregando...");
                      _context.t0 = action.type;
                      _context.next = _context.t0 === _actionTypes.EXECUTE_FUNCTION ? 4 : _context.t0 === _actionTypes.OPEN_URL ? 6 : _context.t0 === _actionTypes.CALL_SERVICE ? 8 : 36;
                      break;
                    case 4:
                      props[action.parameter](item);
                      return _context.abrupt("break", 37);
                    case 6:
                      window.open(action.parameter, "_self");
                      return _context.abrupt("break", 37);
                    case 8:
                      url = action.parameter;
                      params = url.match(/{.+?}/g) || [];
                      params.forEach(function (param) {
                        url = url.replace(param, item[param.replace(/{|}/g, "")]);
                      });
                      if (!(action.httpMethod === "GET")) {
                        _context.next = 17;
                        break;
                      }
                      _context.next = 14;
                      return _api.default.get(url, true);
                    case 14:
                      res = _context.sent;
                      _context.next = 32;
                      break;
                    case 17:
                      if (!(action.httpMethod === "DELETE")) {
                        _context.next = 23;
                        break;
                      }
                      _context.next = 20;
                      return _api.default.delete(url);
                    case 20:
                      res = _context.sent;
                      _context.next = 32;
                      break;
                    case 23:
                      if (!(action.httpMethod === "PUT")) {
                        _context.next = 29;
                        break;
                      }
                      _context.next = 26;
                      return _api.default.putForm(url, {});
                    case 26:
                      res = _context.sent;
                      _context.next = 32;
                      break;
                    case 29:
                      _context.next = 31;
                      return _api.default.postForm(url, {});
                    case 31:
                      res = _context.sent;
                    case 32:
                      setConfirmBtn(false);
                      setCloseText("Ok");
                      setAlertMessage(res[action.resultMessageField]);
                      return _context.abrupt("break", 37);
                    case 36:
                      return _context.abrupt("break", 37);
                    case 37:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function func() {
                return _ref.apply(this, arguments);
              };
            }();
            if (action.confirmationMessage) {
              setAlertMessage(action.confirmationMessage);
              setConfirmText("Confirmar");
              setConfirmBtn(true);
              setCloseText("Cancelar");
              setConfirmFunction(function () {
                return func;
              });
              setShowAlert(true);
            } else if (action.type === _actionTypes.SHOW_DETAIL) {
              setAlertMessage(function () {
                return /*#__PURE__*/_react.default.createElement(_showDetails.default, {
                  item: item,
                  cols: cols,
                  extractCol: extractCol
                });
              });
              setConfirmBtn(false);
              setCloseText("Fechar");
              setShowAlert(true);
            } else {
              func();
            }
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _executeAction.apply(this, arguments);
  }
  function extractCol(_x3, _x4) {
    return _extractCol.apply(this, arguments);
  }
  function _extractCol() {
    _extractCol = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(col, item) {
      var keys, res, itemRes, value, itens, option, formatter;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(col.type === _actionTypes.ACTION)) {
              _context3.next = 6;
              break;
            }
            if (!(col.action.type !== _fieldTypes.CUSTOM)) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", /*#__PURE__*/_react.default.createElement("span", {
              className: "wm-action-button " + col.class,
              onClick: function onClick(e) {
                e.stopPropagation();
                executeAction(col.action, item);
              }
            }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
              icon: ["fas", col.action.icon.substring(3)]
            })));
          case 5:
            return _context3.abrupt("return", props[col.action.parameter](item));
          case 6:
            keys = Object.keys(col);
            res = _objectSpread({}, item);
            keys.forEach(function (key) {
              if (!invalidFieldNames.includes(key)) {
                res = res[col[key]];
              }
            });
            if (!(col.type === _fieldTypes.IMAGE)) {
              _context3.next = 11;
              break;
            }
            return _context3.abrupt("return", /*#__PURE__*/_react.default.createElement("img", {
              src: res[col.name],
              className: "wm-view-img"
            }));
          case 11:
            if (!(col.loadByIdUrl && res[col.name] && col.labelField)) {
              _context3.next = 16;
              break;
            }
            _context3.next = 14;
            return _api.default.get(col.loadByIdUrl + res[col.name], true);
          case 14:
            itemRes = _context3.sent;
            return _context3.abrupt("return", itemRes[col.labelField]);
          case 16:
            value = res[col.name];
            if (!(col.type === _fieldTypes.MULTIPLE_SELECTION || col.type === _fieldTypes.SIMPLE_SELECTION)) {
              _context3.next = 23;
              break;
            }
            _context3.next = 20;
            return auxObj[col.name];
          case 20:
            itens = _context3.sent;
            option = itens.find(function (e) {
              return e[col.valueField || "value"] === value;
            });
            return _context3.abrupt("return", option ? option[col.labelField || "label"] : col.valueField);
          case 23:
            if (col.mask) {
              formatter = new _stringMask.default(col.mask);
              value = formatter.apply(value);
            }
            if (!(typeof value === "boolean")) {
              _context3.next = 26;
              break;
            }
            return _context3.abrupt("return", /*#__PURE__*/_react.default.createElement("input", {
              type: "checkbox",
              id: col.name,
              name: col.name,
              defaultChecked: value,
              disabled: true
            }));
          case 26:
            if (col.type === _fieldTypes.DATE && value) value = (0, _moment.default)(value).format("DD/MM/YYYY");
            if (col.type === _fieldTypes.DATE_TIME && value) value = (0, _moment.default)(value).format("DD/MM/YYYY HH:mm");
            return _context3.abrupt("return", value);
          case 29:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _extractCol.apply(this, arguments);
  }
  function getStrFilters() {
    var keys = Object.keys(filters);
    var strFilters = "";
    keys.forEach(function (key) {
      if (descriptor.filters.filter(function (i) {
        return i.name === key;
      })[0].type !== _fieldTypes.MULTIPLE_SELECTION) strFilters += key + "=" + filters[key] + "&";else strFilters += key + "=" + filters[key].join(",") + "&";
    });
    return strFilters;
  }
  function handleFilter() {
    try {
      setStrFilters(getStrFilters());
      setPage(0);
    } catch (e) {
      console.log(e);
    }
  }
  function getInfos() {
    return _getInfos.apply(this, arguments);
  }
  function _getInfos() {
    _getInfos = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var res, data;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!descriptor.baseUrl) {
              _context4.next = 16;
              break;
            }
            _context4.prev = 1;
            setShowError(null);
            _context4.next = 5;
            return _api.default.get(descriptor.baseUrl + "/filter?" + strFilters + "page=" + page + "&pageSize=" + (props.pageSize || "10") + "&" + sortParam);
          case 5:
            res = _context4.sent;
            setInfos(res.results);
            setPageSize(res.pageSize);
            setTotalElements(res.totalElements);
            setNumPages(res.totalPages);
            if (page >= res.totalPages) setPage(0);
            _context4.next = 16;
            break;
          case 13:
            _context4.prev = 13;
            _context4.t0 = _context4["catch"](1);
            if (_context4.t0.response && _context4.t0.response.data && _context4.t0.response.data.errors) {
              data = _context4.t0.response.data;
              setShowError(data.errors[0].message);
            } else {
              setShowError("Erro ao buscar informações");
            }
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 13]]);
    }));
    return _getInfos.apply(this, arguments);
  }
  function handleClean() {
    _biRef.cleanForm();
    setStrFilters("");
    setPage(0);
  }
  function addPageNumberAsParamInURL(page) {
    var parameters = urlAlreadyHasParams();
    var foundParameters = (parameters === null || parameters === void 0 ? void 0 : parameters.length) > 0;
    var newParameters = foundParameters ? parameters : "?";
    newParameters = newParameters.concat("page=".concat(page + 1));
    window.history.pushState("page ".concat(page + 1), "Title", newParameters);
  }
  function urlAlreadyHasParams() {
    var url = new URL(window.location.href);
    var searchParams = new URLSearchParams(url.search);
    var params = [];
    var newParameters = "?";
    var _iterator = _createForOfIteratorHelper(searchParams.keys()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        params.push({
          key: key,
          value: searchParams.get(key)
        });
        if (key !== "page") newParameters = newParameters.concat("".concat(key, "=").concat(searchParams.get(key), "&"));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (newParameters === "?") return "";
    return newParameters;
  }
  if (biRef) {
    biRef.getInfos = getInfos;
    biRef.getStrFilters = getStrFilters;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "wm-sv-container"
  }, /*#__PURE__*/_react.default.createElement(_popup.default, {
    confirmText: confirmText,
    closeText: closeText,
    confirmBtn: confirmBtn,
    isOpen: showAlert,
    setDisplayPopup: function setDisplayPopup(value) {
      return setShowAlert(value);
    },
    message: alertMessage,
    onConfirm: function onConfirm() {
      return confirmFunction();
    },
    onClose: function onClose() {
      return setShowAlert(false);
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "wm-sv-filters-container " + filtersContainer
  }, /*#__PURE__*/_react.default.createElement(_wmStandardFormContainer.default, {
    biRef: _biRef,
    fields: (descriptor === null || descriptor === void 0 ? void 0 : descriptor.filters) || [],
    errors: {},
    editable: true,
    onChange: function onChange(form) {
      return setFilters(form);
    },
    isFilter: true
  }), showError && /*#__PURE__*/_react.default.createElement("span", {
    className: "wm-view-error"
  }, showError), /*#__PURE__*/_react.default.createElement("div", {
    className: "wm-sv-filters-btn-container " + filtersBtnContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "wm-filter-btn " + filterBtn,
    onClick: handleFilter
  }, /*#__PURE__*/_react.default.createElement("span", null, "Filtrar")), /*#__PURE__*/_react.default.createElement("div", {
    className: "wm-filter-btn wm-clean-btn " + filterCleanBtn,
    onClick: handleClean
  }, /*#__PURE__*/_react.default.createElement("span", null, "Limpar Filtros")), customButtons === null || customButtons === void 0 ? void 0 : customButtons.map(function (customButton, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "wm-filter-btn " + customButton.class,
      onClick: customButton.onClick
    }, /*#__PURE__*/_react.default.createElement("span", null, customButton.text));
  }), addNew && /*#__PURE__*/_react.default.createElement("div", {
    className: "wm-filter-btn wm-add-btn " + addBtn,
    onClick: addNew
  }, /*#__PURE__*/_react.default.createElement("span", null, "+ ", addBtnText)), sortOptions && sortOptions.length > 1 && /*#__PURE__*/_react.default.createElement("select", {
    name: "sort",
    id: "sort-select",
    onChange: function onChange(e) {
      return setSortParam(e.target.value);
    }
  }, sortOptions.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("option", {
      value: item.param
    }, item.label);
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "wm-sv-table-container"
  }, !renderItem && /*#__PURE__*/_react.default.createElement("table", {
    className: "wm-standard-table " + tableContainer
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, cols.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("th", {
      key: (item === null || item === void 0 ? void 0 : item.id) || index,
      className: ((item === null || item === void 0 ? void 0 : item.type) === _actionTypes.ACTION ? "wm-standard-action-th" : "wm-standard-th") + " " + (item !== null && item !== void 0 && item.hideOnMobile ? "mobile-hide" : "") + " " + th + " " + (item !== null && item !== void 0 && item.showOnlyOnMobile ? "mobile-show" : "")
    }, /*#__PURE__*/_react.default.createElement("span", null, item === null || item === void 0 ? void 0 : item.label));
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, infos.map(function (item, item_idx) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: (item === null || item === void 0 ? void 0 : item.id) || item_idx,
      className: "wm-standard-tr " + tr,
      onClick: function onClick() {
        return onItemClick(item);
      }
    }, cols.map(function (col, col_idx) {
      return /*#__PURE__*/_react.default.createElement("td", {
        key: (col === null || col === void 0 ? void 0 : col.id) || col_idx,
        className: (col.type === _actionTypes.ACTION ? "wm-standard-action-td" : "wm-standard-td") + " " + td + " td_" + descriptor.name + "_" + col.name + " " + (col.hideOnMobile ? "mobile-hide" : "") + " " + (col.showOnlyOnMobile ? "mobile-show" : "")
      }, item_idx < displayTable.length && displayTable[item_idx][col_idx]);
    }));
  }))), renderItem && infos.map(function (item) {
    return renderItem(item);
  })), /*#__PURE__*/_react.default.createElement(_pagesController.default, {
    page: page,
    rangeDisplay: rangeDisplay,
    numPages: numPages,
    onPageChange: function onPageChange(page) {
      addPageNumberAsParamInURL(page);
      setPage(page);
    },
    totalElements: totalElements,
    pageSize: pageSize,
    linkClass: pageLinkClass,
    itemClass: pageItemClass,
    activeLinkClass: pageActiveLinkClass
  }));
}
StandardView.defaultProps = {
  descriptor: {},
  pageSize: 10,
  biRef: {},
  filtersContainer: "",
  filtersBtnContainer: "",
  filterBtn: "",
  filterCleanBtn: "",
  customButtons: [],
  addNew: null,
  addBtn: "",
  addBtnText: "Text",
  renderItem: null,
  tableContainer: "",
  th: "",
  tr: "",
  td: "",
  onItemClick: null,
  rangeDisplay: 5,
  pageLinkClass: "",
  pageItemClass: "",
  pageActiveLinkClass: ""
};
StandardView.propTypes = {
  descriptor: _propTypes.default.object,
  pageSize: _propTypes.default.number,
  biRef: _propTypes.default.object,
  filtersContainer: _propTypes.default.string,
  filtersBtnContainer: _propTypes.default.string,
  filterBtn: _propTypes.default.string,
  filterCleanBtn: _propTypes.default.string,
  customButtons: _propTypes.default.array,
  addNew: _propTypes.default.func,
  addBtn: _propTypes.default.string,
  addBtnText: _propTypes.default.string,
  renderItem: _propTypes.default.func,
  tableContainer: _propTypes.default.string,
  th: _propTypes.default.string,
  tr: _propTypes.default.string,
  td: _propTypes.default.string,
  onItemClick: _propTypes.default.func,
  rangeDisplay: _propTypes.default.number,
  pageLinkClass: _propTypes.default.string,
  pageItemClass: _propTypes.default.string,
  pageActiveLinkClass: _propTypes.default.string
};